<div class="nb-theme-default">
    <div class="slider-container">
       <div class="val-input" [style.color]='valid'>
           <span class="prefix">{{prefix}}</span>
           <input id="num-input" #numVal [value]="transform(value)" [min]="min" [max]="max" [step]="step" (change)="numVal.value=onChange(numVal.value)" (change)="rangesldr.value=parse(numVal.value)">
       </div>
           <input type="range"  
           list='dl'
           [min]="min" [max]="max" 
           [step]="step" class="slider" 
           [value]="value" 
           #rangesldr 
           (input)="numVal.value=transform(rangesldr.value)" (change)="onChange(rangesldr.value)" (input)="emphasize(rangesldr.value)">
   </div>
</div>